var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3H2V4H14V3Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12H2V13H14V12Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H2V7H14V6Z",
    fill: "#161616"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9H2V10H14V9Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.26586184d835cfc476fbe1b42aba6511.svg";
export { ForwardRef as ReactComponent };